import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Bauvorhaben hinzufügen")
const _hoisted_2 = { class: "w-full h-full max-h-screen flex flex-col justify-between px-4 pb-4" }
const _hoisted_3 = { class: "w-full h-full pt-4 flex flex-col overflow-y-auto" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Standort eintragen")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold mt-2" }, "Name*:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold mt-2" }, "Land*:", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("DE")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("AT")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("CH")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("LU")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("NL")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold mt-2" }, "Ort*:", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold mt-2" }, "PLZ*:", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold mt-2" }, "Straße:", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold mt-2" }, "Hausnummer:", -1)

import { IonPage, IonHeader, IonContent, IonLabel, IonIcon, IonToolbar, IonButtons, IonChip, IonBackButton, IonTitle, modalController, alertController, loadingController, IonSelect, IonSelectOption } from '@ionic/vue'
import axios from 'axios'
import { Geolocation, Position } from '@capacitor/geolocation';
import CreateConstructionDto from '@/interfaces/construction/CreateConstructionDto';
import { useCompany } from '@/store/company';
import { useCurrentUser } from '@/store/currentUser'
import { location } from 'ionicons/icons'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AddConstructionProjectPage',
  setup(__props) {

const companyStore = useCompany()
const currentUserStore = useCurrentUser()
const constructionData = ref({} as CreateConstructionDto) 

async function dismiss() {
  await modalController.dismiss()
}

async function getAndSetLocation() {
  const loading = await loadingController.create({
    message: 'Bitte warten...',
  })
  await loading.present();

  try {
    const coordinates: Position = await Geolocation.getCurrentPosition({
      enableHighAccuracy: true
    }) 
    if(coordinates.coords.accuracy >= 50) {
      await loading.dismiss()
      const alert = await alertController.create({
        message: 'Standort konnte nicht genau ermittelt werden',
        buttons: ['OK']
      })
      return await alert.present()
    }

    let lat = coordinates.coords.latitude.toString()
    let lon = coordinates.coords.longitude.toString()
    const response = await axios.get('https://discover.search.hereapi.com/v1/autosuggest?at=' + lat + ',' + lon + '&q=' + lat + ',' + lon + '&lang=de_DE&apiKey=' + process.env.VUE_APP_API_KEY_HERE_MAPS)

    let street = ''
    for(let i = 0; i < response.data.items[0].title.split(',')[0].split(' ').length-1; i++) {
      street += response.data.items[0].title.split(',')[0].split(' ')[i] + ' '
    }
    constructionData.value.street = street.trim()
    constructionData.value.city = response.data.items[0].title.split(',')[1].split(' ')[2]
    constructionData.value.zip = response.data.items[0].title.split(',')[1].split(' ')[1]
    constructionData.value.no = response.data.items[0].title.split(',')[0].split(' ')[response.data.items[0].title.split(',')[0].split(' ').length-1]

    if(response.data.items[0].title.split(',')[2].trim() == "Deutschland") {
      constructionData.value.country = "DE"
    }   
  } catch (e: any) {
    let message = ''

    if(e.code === 1) {
      message = 'Fehler beim abrufen deines Standorts. Bitte geben sie uns die Standortberechtigung falls sie das noch nicht getan haben'
    } else if (e.code === 2) {
      message = 'Fehler. Du brauchst eine stabile Internet Verbindung'
    } else if (e.code === 3) {
      message = 'Unerwarteter Fehler aufgetreten'
    }
    
    if(message !== '') {
      const alert = await alertController.create({
        message: message,
        buttons: ['OK']
      })
      await alert.present()
    }
    
  } finally {
    await loading.dismiss()
  }
}

async function saveConstruction() {
  if(constructionData.value.name == "" 
    || constructionData.value.country == "" 
    || constructionData.value.city == "" 
    || constructionData.value.zip == ""
  ) {
    const alert = await alertController.create({
      header: 'Fehler',
      message: 'Bitte füllen Sie alle Felder aus.',
      buttons: ['OK']
    })
    return alert.present()
  }

  try {
    const response = await axios.post(process.env.VUE_APP_PROJECT_API_BASE_URL + "construction", constructionData.value, {
      headers: {
        Authorization: 'Bearer ' + currentUserStore.jwtKey
      }
    })
    await modalController.dismiss(response.data.data._id)
  } catch (e: any) {
    const alert = await alertController.create({
      message: e.response.status + ': Unerwarteter Fehler',
      buttons: ['OK']
    })
    return alert.present()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonBackButton), {
                    text: "",
                    style: {"--color":"#444444"},
                    "default-href": "/addProject",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (dismiss()))
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(IonChip), { onClick: getAndSetLocation }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), { icon: _unref(location) }, null, 8, ["icon"]),
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                enterkeyhint: "next",
                class: "w-full min-h-10 my-1 bg-zewotherm-lightgrey border p-2 font-bold rounded-lg outline-none",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((constructionData.value.name) = $event))
              }, null, 512), [
                [_vModelText, constructionData.value.name]
              ]),
              _hoisted_7,
              _createVNode(_unref(IonSelect), {
                enterkeyhint: "next",
                interface: "popover",
                class: "w-full min-h-10 my-1 bg-zewotherm-lightgrey border p-2 font-bold rounded-lg outline-none",
                modelValue: constructionData.value.country,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((constructionData.value.country) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSelectOption), { value: "DE" }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelectOption), { value: "AT" }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelectOption), { value: "CH" }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelectOption), { value: "LU" }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelectOption), { value: "NL" }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                enterkeyhint: "next",
                class: "w-full min-h-10 my-1 bg-zewotherm-lightgrey border p-2 font-bold rounded-lg outline-none",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((constructionData.value.city) = $event))
              }, null, 512), [
                [_vModelText, constructionData.value.city]
              ]),
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                enterkeyhint: "next",
                class: "w-full min-h-10 my-1 bg-zewotherm-lightgrey border p-2 font-bold rounded-lg outline-none",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((constructionData.value.zip) = $event))
              }, null, 512), [
                [_vModelText, constructionData.value.zip]
              ]),
              _hoisted_15,
              _withDirectives(_createElementVNode("input", {
                enterkeyhint: "next",
                class: "w-full min-h-10 my-1 bg-zewotherm-lightgrey border p-2 font-bold rounded-lg outline-none",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((constructionData.value.street) = $event))
              }, null, 512), [
                [_vModelText, constructionData.value.street]
              ]),
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                enterkeyhint: "next",
                class: "w-full min-h-10 my-1 bg-zewotherm-lightgrey border p-2 font-bold rounded-lg outline-none",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((constructionData.value.no) = $event))
              }, null, 512), [
                [_vModelText, constructionData.value.no]
              ])
            ]),
            _createElementVNode("button", {
              style: _normalizeStyle('background-color: ' + _unref(companyStore).activeCompany.color),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (saveConstruction())),
              class: "w-full min-h-10 text-white font-bold rounded-lg cursor-pointer mt-3 active:scale-95 duration-200"
            }, "Speichern", 4)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})